export default function createIconPalette(theme, current, _base) {
    return {
        icon: {
            color: current[500],
        },
    };
}
//# sourceMappingURL=icon.js.map